import React, { Component } from 'react';
import GoogleMapLoader from "react-google-maps-loader"
import GooglePlacesSuggest from "react-google-places-suggest"
import Geocode from "react-geocode"

const MY_API_KEY = 'AIzaSyCq8un3ZFv07xccmNCKDo-B69OhxppykYM';

class GoogleSuggest extends Component {
    constructor() {
        super();

        this.state = {
            search: "",
            value: "",
        }

        this.handleInputChange = e => {
            this.setState({ search: e.target.value, value: e.target.value })
        }
        this.handleSelectSuggest = (geocodedPrediction, originalPrediction) => {
            console.log(geocodedPrediction, originalPrediction) // eslint-disable-line
            this.setState({ search: "", value: geocodedPrediction.formatted_address })
            const onChange = this.props.onChange
            if (onChange) {
                onChange({ value: { formatted_address: geocodedPrediction.formatted_address, geometry: { lat: geocodedPrediction.geometry.location.lat(), lng: geocodedPrediction.geometry.location.lng() } } })
            }
        }

        Geocode.setLanguage("en")
        Geocode.setRegion("nz")
        Geocode.setApiKey(MY_API_KEY)

    }

    componentDidMount() {
        let currentComponent = this
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
                Geocode.fromLatLng(position.coords.latitude, position.coords.longitude).then(
                    response => {
                        const address = response.results[0].formatted_address
                        currentComponent.setState({ search: "", value: address })
                        const onChange = currentComponent.props.onChange
                        if (onChange) {
                            onChange({ value: { formatted_address: address, geometry: { lat: position.coords.latitude, lng: position.coords.longitude }} })
                        }
                    },
                    error => {
                        console.log(error)
                    }
                )
            },
            typeErr => {
                console.log(typeErr) // Permission denied etc
            })
        }
    }

    render() {
        return (
            <GoogleMapLoader
                params={{
                    key: MY_API_KEY,
                    libraries: "places,geocode",
                }}
                render={googleMaps =>
                    googleMaps && (
                        <   GooglePlacesSuggest
                            googleMaps={googleMaps}
                            autocompletionRequest={{
                                input: this.state.search,
                                bounds: {
                                    north: -42.29356,
                                    east: 173.77075,
                                    south: -44.54350,
                                    west: 170.89233
                                },
                                componentRestrictions: {
                                    country: 'nz'
                                }
                                // Optional options
                                // https://developers.google.com/maps/documentation/javascript/reference?hl=fr#AutocompletionRequest
                            }}
                            // Optional props
                            onSelectSuggest={this.handleSelectSuggest}
                        >
                            <input
                                type="text"
                                className="text-field"
                                value={this.state.value}
                                placeholder="i.e 12 avalon crescent"
                                onChange={this.handleInputChange}
                            />
                        </GooglePlacesSuggest>
                    )
                }
            />
        )
    }
}
export default GoogleSuggest;